"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'branch.delete.confirm.title': '删除行业',
    'branch.delete.confirm.message': '确定要删除此行业吗？',
};
